// extracted by mini-css-extract-plugin
export default {"custom_btn":"resetPasswordForm_custom_btn__5qRjx"};